import { render, staticRenderFns } from "./SafeEditProject.vue?vue&type=template&id=21441d04&scoped=true&"
import script from "./SafeEditProject.vue?vue&type=script&lang=js&"
export * from "./SafeEditProject.vue?vue&type=script&lang=js&"
import style0 from "./SafeEditProject.vue?vue&type=style&index=0&id=21441d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21441d04",
  null
  
)

export default component.exports